import { ApolloLink, Observable } from '@apollo/client/core';
import { getCurrentAccessToken } from '@/api/auth';
async function authorise(operation) {
    const context = operation.getContext();
    const Authorization = await getCurrentAccessToken();
    const headers = {
        Authorization,
        ...(context.headers || {}),
    };
    operation.setContext({
        ...context,
        headers,
    });
}
function cognitoLink() {
    return new ApolloLink((operation, forward) => new Observable((observer) => {
        let handle;
        Promise.resolve(operation)
            .then((o) => authorise(o))
            .then(() => {
            handle = forward(operation).subscribe({
                next: observer.next.bind(observer),
                error: observer.error.bind(observer),
                complete: observer.complete.bind(observer),
            });
        })
            .catch(observer.error.bind(observer));
        return () => {
            if (handle) {
                handle.unsubscribe();
            }
        };
    }));
}
class CognitoLink extends ApolloLink {
    link;
    constructor() {
        super();
        this.link = cognitoLink();
    }
    request(operation, forward) {
        return this.link.request(operation, forward);
    }
}
const thisCognitoLink = new CognitoLink();
export default thisCognitoLink;
